import React, { useEffect, useState } from 'react';
import { ButtonWithAnchor } from '../../income-tax/page-sections/hero-section/sticky-button';
import { ButtonVariants } from '../../Atoms/Button';
import { HomepageStickyCTAProps } from '../types';

const HomepageStickyCTA: React.FC<HomepageStickyCTAProps> = ({
  heroCardsRef,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const heroCardsElement = heroCardsRef.current;

    if (!heroCardsElement) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          setIsVisible(!entry.isIntersecting);
        });
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.2,
      }
    );

    observer.observe(heroCardsElement);

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div
      className={`fixed hidden left-0 -bottom-4 bg-white w-full sm:justify-center p-4 z-40 items-center sm:flex flex-col gap-2 transition-all duration-500 ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'
      }`}
      style={{ boxShadow: '0px -3px 10px rgba(0, 0, 0, 0.062)' }}
    >
      <ButtonWithAnchor
        buttonText="File now"
        buttonLink="https://cleartax.in/filing?utm_ref=itr_2025_organic_homepage_sticky_bottom_button"
        trackLabel="sticky_bottom_button_new"
        buttonVariant={ButtonVariants.bluefilled}
        className="w-full"
      />
      <ButtonWithAnchor
        buttonText="Hire an Expert"
        buttonLink="https://cleartax.in/s/pricing?utm_ref=cleartax_homepage_herofold"
        trackLabel="sticky_bottom_button_new"
        buttonVariant={ButtonVariants.bluebordered}
        className="w-full"
      />
    </div>
  );
};

export default HomepageStickyCTA;
